// Auth endpoints
export const LOGIN_URL = '/api/crm/login';
export const LOGOUT_URL = '/api/crm/logout';
export const FORGOT_PASSWORD_URL = '/api/crm/forgot-password';
export const RESET_PASSWORD_URL = '/api/crm/reset-password';

// Dashboard endpoints
export const DASHBOARD_OVERVIEW_URL = '/api/crm/dashboard';
export const DASHBOARD_DONORS_WITH_LIMITS_URL = '/api/crm/get-call-list-donors';
export const DASHBOARD_LIMIT_EXCEEDED_URL = '/api/crm/limit-exceeded-donors';
export const DASHBOARD_LIMIT_APPROACHING_URL = '/api/crm/limit-approaching-donors';
export const DASHBOARD_GET_CALL_LIST_URL = '/api/crm/list-call-list';

// User endpoints
export const GET_USERS_URL = '/api/crm/users';
export const ADD_USER_URL = '/api/crm/add-user';
export const UPDATE_USER_URL = '/api/crm/users'; // /:id will be appended
export const GET_USER_DETAILS_URL = '/api/crm/get-user-details';

// Donor endpoints
export const GET_TOP_DONORS_URL = '/api/crm/top-donors';
export const PRINT_DONORS_URL = '/api/crm/print-donors';
export const DOWNLOAD_DONORS_TO_CALL_URL = '/api/crm/print-call-list';
export const GET_CHART_DATA_URL = '/api/crm/chart-data';
export const GET_DONOR_DETAILS_URL = '/api/crm/get-donor-details';

// Persist user endpoints
export const PERSIST_USER_URL = '/api/crm/me';




